import JSZip from 'jszip'

export const IMAGE_TYPES = Object.freeze({
  ORIGINAL: 'ORIGINAL',
  OPTIMIZED: 'OPTIMIZED'
})

function getFileExtensionFromUrl(url) {
  const path = new URL(url).pathname
  const dot = path.lastIndexOf('.')
  return dot === -1 ? 'jpg' : path.substring(dot + 1)
}

export async function buildImagesZip(images, baseName) {
  const zip = new JSZip()

  const entries = await Promise.all(
    images.map(async (img) => {
      const res = await fetch(img.url)
      if (!res.ok) throw new Error(`Failed to fetch ${img.url}`)
      const blob = await res.blob()
      const name = `${baseName}_${img.order}.${getFileExtensionFromUrl(img.url)}`
      return { order: img.order, name, blob }
    })
  )

  entries.sort((a, b) => a.order - b.order).forEach(({ name, blob }) => zip.file(name, blob))

  return zip.generateAsync({ type: 'blob' })
}
